import { render, staticRenderFns } from "./IntegracaoEstabelecimento.vue?vue&type=template&id=208cdd59&"
import script from "./IntegracaoEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./IntegracaoEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports